import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import React, { useCallback } from 'react';
import { useRecoilState } from 'recoil';
import BeaconFilterItem from '../../../models/BeaconFilterItem';
import stateDiseases from '../../../state/stateDiseases';
import stateFilterDisease from '../../../state/stateFilterDisease';

function QueryDisease() {
  const [diseases] = useRecoilState(stateDiseases);
  const [filterDisease, setFilterDisease] = useRecoilState(stateFilterDisease);
  const handleChange = useCallback(
    (
      event: React.SyntheticEvent<Element, Event>,
      value: BeaconFilterItem | null
    ) => {
      if (((value || {}).id || '') !== ((filterDisease || {}).id || '')) {
        setFilterDisease(value);
      }
    },
    [filterDisease, setFilterDisease]
  );

  if (0 < diseases.length) {
    return (
      <Autocomplete
        fullWidth
        disablePortal
        options={diseases}
        renderInput={(params) => <TextField {...params} margin="dense" />}
        value={filterDisease}
        onChange={handleChange}
        size="small"
      />
    );
  } else {
    return <CircularProgress />;
  }
}

export default QueryDisease;
